import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';

import { isChrome, isIE, isSafari } from '../helpers';
import ReactGA from 'react-ga';

import './Style';

class WalkthruContainer extends Component {
    constructor(props) {
      super(props)

      this.state = {
            videoFrameHeight: 360,
            error: null,
            errorInfo: null,
            player: null,
            playerPaused: true
        }

        this.onResize = this.onResize.bind(this);
        this.toggleVideo = this.toggleVideo.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize, false);
        if (this.overlay) {
            this.overlay.addEventListener('click', this.toggleVideo, false);
        }
        this.onResize();

        window.addEventListener('message', (e) => {
            console.log('post-m-story', e.data);
            const { presentation } = e.data
            if (presentation) {
                this.setState({
                    presentation: true
                })
            }
        })

        if (this.player) {
            this.setState({
                player: this.player.player.player
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false);
        if (this.overlay) {
            this.overlay.removeEventListener('click', this.toggleVideo, false);
        }
    }

    onResize() {
        if (!this.props.walkthruVideo || !this.header) {
            return false;
        }

        const headerMargin = Number(window.getComputedStyle(this.header).marginBottom.replace('px', ''))
            + Number(window.getComputedStyle(this.header).marginTop.replace('px', ''));
        const headerHeight = this.header.offsetHeight + headerMargin;

        if (window.screen.availHeight * 0.95 < window.innerWidth * 9 / 16) {
            this.setState({
                videoFrameHeight: window.screen.availHeight * 0.95 + headerHeight
            });
        } else {
            this.setState({
                videoFrameHeight: window.innerWidth * 9 / 16 + headerHeight
            });
        }
    }

    toggleVideo(e) {
        const { player, playerPaused } = this.state;
        e.stopPropagation();
        if (playerPaused) {
            // ReactGA.event({
            //     category: 'video',
            //     action: 'play walkthru'
            // });

            player.play();
            this.setState({ playerPaused: false });
        } else {
            // ReactGA.event({
            //     category: 'video',
            //     action: 'pause walkthru'
            // });

            player.pause();
            this.setState({ playerPaused: true });
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        });
    }

    getPoster(poster) {
        if (!poster) {
            return ''
        }
        const fullFilename = poster.path  + encodeURIComponent(poster.file_name);
        return fullFilename
    }

    render () {
        const { walkthruVideo, poster } = this.props;
        const { videoFrameHeight, error, playerPaused } = this.state;

        if (!walkthruVideo || error) {
            return null;
        }

        let browserName = '';

        if (isChrome()) {
            browserName = 'chrome';
        }

        if (isIE()) {
            browserName = 'ie';
        }

        if (isSafari()) {
            browserName = 'safari';
        }

        const customVideoPlayBlock =  isChrome() || isIE() || isSafari()
            ? (
                <div className={`play-button ${browserName}`} ref={overlay => this.overlay = overlay}>
                    <i
                        className={`fa fa-play-circle${playerPaused ? '' : ' hidden'}`}
                        ref={playBtn => this.playBtn = playBtn}>
                    </i>
                </div>
            )
            : null;

        return (
            <div
                id="walkthru"
                className="walkthru-container"
                style={this.state.presentation ? { height: document.body.offsetWidth * (3 / 4) } : { height: videoFrameHeight + 'px' }}>
                <h2 className="section-header" ref={header => this.header = header}>
                    Slideshow Video
                </h2>
                <div className="walkthru-component">
                    <ReactPlayer
                        ref={player => this.player = player}
                        className="video-wrapper"
                        url={walkthruVideo}
                        width='100%'
                        controls={true}
                        config={
                            {
                                file: {
                                    attributes: {
                                        preload: 'none',
                                        poster:  this.getPoster(poster),
                                        playsInline: true
                                    } 
                                }
                            }
                        }
                        onPlay={() => {
                                this.setState({
                                    playerPaused: false
                                })
                        }}
                        onPause={() => {
                                this.setState({
                                    playerPaused: true
                                })
                        }}
                    />
                    {customVideoPlayBlock}
                </div>
            </div>
        )
    }
}

WalkthruContainer.propTypes = {
    walkthruVideo: PropTypes.string.isRequired
}

const mapStateToProps = (state) => ({
    walkthruVideo: state.video.walkthruVideo,
    poster: state.app.backgroundPhoto
});

export default connect(mapStateToProps)(WalkthruContainer)
